var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ot)?_c('div',{staticClass:"otDisplay"},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label)+": ")]):_vm._e(),_vm._v(_vm._s(_vm._f("otHours")(_vm.ot))+" "),(_vm.remark)?_c('span',[_vm._v("("+_vm._s(_vm.remark)+")")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }